export var cBridgeContracts = [
    { address: '0x5427FEFA711Eff984124bFBB1AB6fbf5E3DA1820', chainId: 1, name: 'Celer Bridge Mainnet' },
    { address: '0x1619DE6B6B20eD217a58d00f37B9d47C7663feca', chainId: 42161, name: 'Celer Bridge Arbitrum' },
    { address: '0x9D39Fc627A6d9d9F8C831c16995b209548cc3401', chainId: 10, name: 'Celer Bridge Optimism' },
];
export var REACT_APP_GRPC_SERVER_URL = 'https://cbridge-prod2.celer.app';
